var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-table',{attrs:{"url":_vm.url,"table-columns":_vm.tableColumns,"form-fields":_vm.formFields,"searchs":_vm.searchs,"operate":[],"permission":_vm.permission}})}
var staticRenderFns = []

export { render, staticRenderFns }